import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Space, message, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../utils/api';
import { useMenuPermission } from '../hooks/useMenuPermission';

function TeamManage() {
  const { canEdit } = useMenuPermission();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await api.get('/teams');
      if (res.code === 200) setData(res.data);
    } catch (err) {}
    setLoading(false);
  };

  const handleAdd = () => {
    setEditingItem(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingItem(record);
    form.setFieldsValue(record);
    setModalVisible(true);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      let res;
      if (editingItem) {
        res = await api.put(`/teams/${editingItem.id}`, values);
      } else {
        res = await api.post('/teams', values);
      }
      if (res.code === 200) {
        message.success(editingItem ? '更新成功' : '创建成功');
        setModalVisible(false);
        loadData();
      }
    } catch (err) {}
  };

  const handleDelete = async (id) => {
    try {
      const res = await api.delete(`/teams/${id}`);
      if (res.code === 200) {
        message.success('删除成功');
        loadData();
      }
    } catch (err) {}
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 80 },
    { title: '小组名称', dataIndex: 'name' },
    {
      title: '创建时间', dataIndex: 'created_at', width: 180,
      render: v => v ? new Date(v).toLocaleString() : '-'
    },
    {
      title: '操作', key: 'action', width: 150,
      render: (_, record) => (
        <Space>
          {canEdit && <Button type="link" size="small" icon={<EditOutlined />} onClick={() => handleEdit(record)}>编辑</Button>}
          {canEdit && (
            <Popconfirm title="确定删除？" onConfirm={() => handleDelete(record.id)}>
              <Button type="link" size="small" danger icon={<DeleteOutlined />}>删除</Button>
            </Popconfirm>
          )}
        </Space>
      )
    }
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <h3>小组管理</h3>
        {canEdit && <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>新增小组</Button>}
      </div>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
      />

      <Modal
        title={editingItem ? '编辑小组' : '新增小组'}
        open={modalVisible}
        onOk={handleSave}
        onCancel={() => setModalVisible(false)}
        width={400}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="小组名称" rules={[{ required: true, message: '请输入小组名称' }]}>
            <Input placeholder="例如：一组、二组" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default TeamManage;
